export const rating = [
  {
    _id: 0,
    name: 0,
    array: [0],
  },
  {
    _id: 1,
    name: 3,
    array: [3],
  },
  {
    _id: 2,
    name: 3.5,
    array: [3.5],
  },
  {
    _id: 3,
    name: 4,
    array: [4],
  },
  {
    _id: 4,
    name: 4.5,
    array: [4.5],
  },
];
